export default __webpack_public_path__ + "static/media/f-avatar.7e255f7e.png";